import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// Actions
import isSchoolEmail from '../utils/reusable_functions/isSchoolEmail';
import { followGroup } from '../actions/authActions';
  
// -- Trigger Side Effects on page load --
const TriggerSideEffects = ({
    nav: {
        website,
        website_loading,
        valid_Email_Exts
    },
    auth: {
        user
    },
    followGroup
}) =>  {

    // --- For Custom URLs Only ---

    // Check if user's school email is verified and if it matches this schools email extensions
    // if yes, auto-follow the group (if the user does not already follow it)
    // without this a user has no way to post if they unfollowed the group on the main Buy Sell App
    useEffect(() => {
        if(!website || !user || !user?.school_verified || !user?.school_email) return;

        console.log('Performing audit: Check if user follows this group');

        let followsGroup = false;

        if(user?.groups?.includes(website?._id)) {
            followsGroup = true;
        }

        if(followsGroup) return;

        if (!followsGroup && !website_loading) {

            console.log('User does not follow this group');

            if(isSchoolEmail(user?.school_email, valid_Email_Exts)) {

                console.log('Auto-following group');
                // Auto follow this group for current user
                followGroup(website?._id, user);
            }
        }
        
    }, [user, website]); // Dependency array ensures this runs once

    // --- END: For Custom URLs Only ---

    return null;
}
  
TriggerSideEffects.propTypes = {
    nav: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    followGroup: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    
    // Mapping the auth state from the Redux store to the 'auth' prop
    auth: state.auth,
    nav: state.nav
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    followGroup
})(TriggerSideEffects);
  